var letters;

letters = function() {
  var $, TweenLite, getLettersCoords, lettersBack, module, moduleName, patternWrapper;
  TweenLite = require("gsap");
  $ = require('jquery');
  moduleName = 'letters';
  module = $("." + moduleName);
  lettersBack = module.find("." + moduleName + "__bg");
  if (lettersBack.length > 0) {
    getLettersCoords = function(e, box) {
      var BCbox, boxChild, letter, patternLetters;
      boxChild = box.querySelector("." + moduleName + "__bg>svg");
      $(boxChild).addClass('svg_hovered');
      $(boxChild).attr('id', 'svgjs_getter');
      letter = boxChild.querySelectorAll(".svg_letter");
      patternLetters = box.querySelector(".svg_hovered");
      BCbox = patternLetters.getBoundingClientRect();
      return $(letter).each(function() {
        var Bbox, Xdiff, Xpoint, Ydiff, Ypoint, parentPattern;
        Bbox = this.getBBox();
        Xpoint = e.clientX - BCbox.left;
        Ypoint = e.clientY - BCbox.top;
        Xdiff = Xpoint - Bbox.x;
        Ydiff = Ypoint - Bbox.y;
        if (Xdiff < 20 && Ydiff < 20 || Xdiff > -20 && Ydiff > -20) {
          parentPattern = $(this).parents('.svg_hovered');
          TweenLite.to(this, 1, {
            x: 10,
            y: 10,
            transformOrigin: "50% 50%",
            ease: Elastic.easeOut.config(0.5, 0.2)
          });
          return $(this).addClass('mousenear');
        } else {
          if ($(this).hasClass('mousenear')) {
            TweenLite.to(this, 1, {
              x: 0,
              y: 0,
              transformOrigin: "50% 50%",
              ease: Elastic.easeOut.config(0.5, 0.2)
            });
            return $(this).removeClass('mousenear');
          }
        }
      });
    };
    patternWrapper = module.find("." + moduleName + "__box");
    patternWrapper.on('mousemove', function(event) {
      var wrapper;
      wrapper = this;
      return getLettersCoords(event, wrapper);
    });
    return patternWrapper.on("mouseout", function(event) {
      var thisWrapper;
      thisWrapper = this.querySelector("." + moduleName + "__bg>svg");
      $(thisWrapper).removeClass('svg_hovered');
      return $(thisWrapper).removeAttr('id');
    });
  }
};

module.exports = letters;
